import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ApiModeProvider } from './context/ApiModeContext';
import { PartnersProvider } from './context/PartnersContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import Dashboard from './pages/Dashboard';
import Partners from './pages/Partners';
import Customers from './pages/Customers';
import Beneficiaries from './pages/Beneficiaries';
import BankAccounts from './pages/BankAccounts';
import Payments from './pages/Payments';
import MasterDataCountries from './pages/master-data/MasterDataCountries';
import MasterDataExchangeRate from './pages/master-data/MasterDataExchangeRate';
import MasterDataPurposeCodes from './pages/master-data/MasterDataPurposeCodes';
import MasterDataPaymentMethods from './pages/master-data/MasterDataPaymentMethods';
import MasterDataCustomerDocuments from './pages/master-data/MasterDataCustomerDocuments';
import PaymentModes from './pages/PaymentModes';
import ReceiverMode from './pages/ReceiverMode';
import EDDRules from './pages/EDDRules';
import KYC from './pages/KYC';
import Compliance from './pages/Compliance';
import Settings from './pages/Settings';
import './App.css';

// Simple auth check (client-side only, no real backend)
const isAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === 'true';
};

const PrivateRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <ApiModeProvider>
      <Router>
        <PartnersProvider>
          <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/partners"
          element={
            <PrivateRoute>
              <Partners />
            </PrivateRoute>
          }
        />
        <Route
          path="/customers"
          element={
            <PrivateRoute>
              <Customers />
            </PrivateRoute>
          }
        />
        <Route
          path="/beneficiaries"
          element={
            <PrivateRoute>
              <Beneficiaries />
            </PrivateRoute>
          }
        />
        <Route
          path="/bank-accounts"
          element={
            <PrivateRoute>
              <BankAccounts />
            </PrivateRoute>
          }
        />
        <Route
          path="/customer-documents"
          element={
            <PrivateRoute>
              <MasterDataCustomerDocuments />
            </PrivateRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <PrivateRoute>
              <Payments />
            </PrivateRoute>
          }
        />
        <Route
          path="/master-data"
          element={
            <PrivateRoute>
              <Navigate to="/master-data/countries" replace />
            </PrivateRoute>
          }
        />
        <Route
          path="/master-data/countries"
          element={
            <PrivateRoute>
              <MasterDataCountries />
            </PrivateRoute>
          }
        />
        <Route
          path="/master-data/exchange-rate"
          element={
            <PrivateRoute>
              <MasterDataExchangeRate />
            </PrivateRoute>
          }
        />
        <Route
          path="/master-data/purpose-codes"
          element={
            <PrivateRoute>
              <MasterDataPurposeCodes />
            </PrivateRoute>
          }
        />
        <Route
          path="/master-data/payment-methods"
          element={
            <PrivateRoute>
              <MasterDataPaymentMethods />
            </PrivateRoute>
          }
        />
        <Route
          path="/payment-modes"
          element={
            <PrivateRoute>
              <PaymentModes />
            </PrivateRoute>
          }
        />
        <Route
          path="/receiver-mode"
          element={
            <PrivateRoute>
              <ReceiverMode />
            </PrivateRoute>
          }
        />
        <Route
          path="/edd-rules"
          element={
            <PrivateRoute>
              <EDDRules />
            </PrivateRoute>
          }
        />
        <Route
          path="/kyc"
          element={
            <PrivateRoute>
              <KYC />
            </PrivateRoute>
          }
        />
        <Route
          path="/compliance"
          element={
            <PrivateRoute>
              <Compliance />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
          </Routes>
        </PartnersProvider>
      </Router>
    </ApiModeProvider>
  );
}

export default App;
